module.exports = __webpack_public_path__ + "img/t1.3378adf0.png";